const videoWallTutorial = {
  module: 'video_wall',
  moduleName: 'Video Wall',
  steps: [
    { target: '.vw-sidebar', position: 'right', title: 'Camera Sidebar', description: 'Browse and drag cameras onto the video wall grid.' },
    { target: '.vw-sidebar-search', position: 'bottom', title: 'Search', description: 'Quickly find cameras by name across all your VMS systems.' },
  ],
};
export default videoWallTutorial;
